import React from 'react';
import './style.scss';
import { Form, Select } from 'antd';
import PropTypes from 'prop-types';

const { Option } = Select;

const DropdownForm = ({ placeholder, list, customClass, name, isRequired, handleChange, initialValue }) => {

  let rules = [];
  if (isRequired) {
    rules = [
      {
        required: true,
        message: 'Required field cannot be left blank',
      },
      ...rules,
    ]
  }

  return (
    <Form.Item className={`dropdown-form ${customClass || ''}`} name={name} rules={rules} initialValue={initialValue}>
      <Select placeholder={placeholder} onChange={handleChange} >
        {list.map((item, index) => (
          <Option value={item.value} key={index}>{item.text}</Option>
        ))}
      </Select>
    </Form.Item>
  );
}

DropdownForm.propTypes = {
  list: PropTypes.array,
};

DropdownForm.defaultProps = {
  list: [],
};

export default React.memo(DropdownForm);
